import {
  apiRequest,
  skpBaruCreate,
  skpBaruUpdate,
  employeeList,
  individualcriterialist,
  skppernipCreate,
  getposition,
  checkExistingEmployeeSkp
} from "../../../../../services/adapters/kepegawaian/skpBaruService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      skpBaruCreate,
      {
        body: query,
      },
      true
    );
  };
  
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      skpBaruUpdate,
      {
        body: query,
      },
      true
      );
    };
    
    fetchEmployee = async (query) => {
      return await apiRequest("get", employeeList, {
        params: query
      }, true)
    }
    fetchIndividualCriteria = async (query) => {
      return await apiRequest("get", individualcriterialist, {
        params: query
      }, true)
    }
    
    fetchCreatepernip = async (query) => {
      return await apiRequest(
        "post",
        skppernipCreate,
        {
          body: query,
        },
        true
        );
      };
      
      fetchPosition = async (query) => {
        return await apiRequest("get", getposition, {
          params: query
        }, true)
      }
      
      fetchCheckExistingSkp = async (query) => {
        return await apiRequest(
            "post",
            checkExistingEmployeeSkp,
            { body: query },
            true
        );
      }
}

export default CreateRepository;
